import {
    GET_COUNTY_LIST_SUCCESS
} from '../constants/get_county_list.constants';

export const getCountyListSuccess = payload => ({
    type: GET_COUNTY_LIST_SUCCESS,
    payload,
});


// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/get_county_list.actions.js